import { api } from "@/http/api-client"

import type { TListSubscribersResponse } from "./types"

export type TListSubscribersParams = {
  serviceId: string
  organizationSlug: string
}

export function listSubscribers(params: TListSubscribersParams) {
  const searchParams = new URLSearchParams()
  searchParams.set("organizationSlug", params.organizationSlug)

  return api.get<TListSubscribersResponse>(
    `/changelog/services/${params.serviceId}/subscribers?${searchParams.toString()}`,
  )
}
